export type PreservationStatus = {
  id: number;
  name: string;
};

export const PRESERVATION_STATUSES = [
  {
    id: 4,
    name: "Backlog",
  },
  {
    id: 1,
    name: "Pending",
  },
  {
    id: 3,
    name: "In Progress",
  },
  {
    id: 2,
    name: "Complete",
  },
  {
    id: 5,
    name: "Canceled",
  },
];

export type PreservationTriggerType = {
  id: number;
  name: string;
};

export const PRESERVATION_TRIGGER_TYPES = [
  {
    id: 1,
    name: "Litigation",
  },
  {
    id: 2,
    name: "Subpoena",
  },
  {
    id: 3,
    name: "Internal Investigation",
  },
  {
    id: 4,
    name: "Regulatory",
  },
  {
    id: 5,
    name: "Other",
  },
];

export type PreservationMethod = {
  id: number;
  name: string;
};

export const PRESERVATION_METHODS = [
  {
    id: 1,
    name: "In-Place Hold",
  },
  {
    id: 2,
    name: "Export",
  },
  {
    id: 3,
    name: "Snapshot",
  },
  {
    id: 4,
    name: "Forensic Image",
  },
];
